import React from "react";
import leftArrow from "../../assests/left arrow.svg";
import style from "./PracticeListDetail.module.css";
import proficiency from "../../assests/proficiency.svg";
import calender from "../../assests/calender.svg";
import question from "../../assests/question.svg";
import time from "../../assests/time.svg";
import favorite from "../../assests/favorite.svg";

function PracticeListDetail() {
  return (
    <div className={style.container}>
      <div className={style.topicHeader}>
        <img src={leftArrow} className={style.backButton} alt="left arrow" />
        <div className={style.headingP}>
          <p className={style.subtopicHP}>Subtopic 2 - Practice</p>
          <p className={style.subtopicHeadingP}>Assertive sentences</p>
        </div>
      </div>

      <div className={style.skillContaniner}>
        <div className={style.skillBox}>
          <p className={style.skillNo}> Skill 1</p>
          <p className={style.skillName}>
            {" "}
            Identify subject and predicate in a sentence
          </p>
        </div>
      </div>

      <div className={style.skillDataContaniner}>
        <div className={style.skillBox}>
          <p className={style.skillNo}> Skill 2</p>
          <div className={style.skillDataContainer}>
            <p className={style.skillName}>
              {" "}
              Identify subject and predicate in a sentence
            </p>

            <div className={style.dataContainer}>
              <div className={style.proficiencyContainer}>
                <div className={style.titleBox}>
                  <p>Proficiency</p>
                  <img src={proficiency} alt="" />
                </div>
                <div className={style.progressBarContainer}>
                  <div className={style.progressBar}>
                    <div className={style.segmentFilled}></div>
                    <div className={style.segmentFilled}></div>
                    <div className={style.segmentFilled}></div>
                    <div className={style.segmentFilled}></div>
                    <div className={style.segmentEmpty}></div>
                  </div>
                </div>
              </div>

              <div className={style.dateContainer}>
                <div className={style.titleBox}>
                  <p>Last Practiced</p>
                  <img src={calender} alt="" />
                </div>
                <span className={style.statValue}>27-03-2025</span>
              </div>

              <div className={style.answerdataContainer}>
                <div className={style.titleBox}>
                  <p>Answered</p>
                  <img src={question} alt="" />
                </div>
                <span className={style.answerdata}>8</span>
              </div>

              <div className={style.timecontianer}>
                <div className={style.titleBox}>
                  <p>Time Spent</p>
                  <img src={time} alt="" />
                </div>
                <span className={style.timedata}>15:07</span>
              </div>

              <div className={style.scoreContianer}>
                <div className={style.titleBox}>
                  <p>Score</p>
                  <img src={favorite} alt="" />
                </div>
                <span className={style.scoredata}>55/100</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PracticeListDetail;
